import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Recolecciones from './pages/Recolecciones';
import Zonas from './pages/Zonas';
import Moviles from './pages/Moviles';
import Servicios from './pages/Servicios';
import Causas from './pages/Causas';
import Contribuyentes from './pages/Contribuyentes';
import Itinerarios from './pages/Itinerarios';
import Reportes from './pages/Reportes';
import Usuarios from './pages/Usuarios';
import Configuracion from './pages/Configuracion';
import ApiKeys from './pages/ApiKeys';
import { useAuthStore } from './store/authStore';

function App() {
  const { isAuthenticated } = useAuthStore();

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Layout>
                <Dashboard />
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/recolecciones"
          element={
            isAuthenticated ? (
              <Layout>
                <Recolecciones />
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/zonas"
          element={
            isAuthenticated ? (
              <Layout>
                <Zonas />
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/moviles"
          element={
            isAuthenticated ? (
              <Layout>
                <Moviles />
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/servicios"
          element={
            isAuthenticated ? (
              <Layout>
                <Servicios />
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/causas"
          element={
            isAuthenticated ? (
              <Layout>
                <Causas />
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/contribuyentes"
          element={
            isAuthenticated ? (
              <Layout>
                <Contribuyentes />
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/itinerarios"
          element={
            isAuthenticated ? (
              <Layout>
                <Itinerarios />
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/reportes"
          element={
            isAuthenticated ? (
              <Layout>
                <Reportes />
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/usuarios"
          element={
            isAuthenticated ? (
              <Layout>
                <Usuarios />
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/configuracion"
          element={
            isAuthenticated ? (
              <Layout>
                <Configuracion />
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/api-keys"
          element={
            isAuthenticated ? (
              <Layout>
                <ApiKeys />
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </Box>
  );
}

export default App;
